import * as Sentry from '@sentry/react'

const environment = process.env.RELEASE_ENV
if (['production', 'staging'].includes(environment)) {
  /**
   * Errors with descriptions which contain the following strings will be ignored
   * and not reported to Sentry.
   *
   * See https://docs.sentry.io/clients/javascript/config/
   *
   * [1] This error is throw outside our app as part of Office 365's Safe Link
   *     functionality. See https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-865857552
   */
  const SENTRY_IGNORED_ERRORS = [
    'Object Not Found Matching Id', // [1]
  ]

  const dsn = process.env.SENTRY_API_URL
  const release = process.env.RELEASE_HASH
  Sentry.init({
    dsn,
    release,
    environment,
    ignoreErrors: SENTRY_IGNORED_ERRORS,
    beforeBreadcrumb(breadcrumb) {
      // Ignore Snowplow XHRs in Sentry breadcrumbs as they are extremely noisy.
      if (
        breadcrumb.type == 'http' &&
        breadcrumb.data?.url?.startsWith(
          'https://tracker.snowplow-farewill.com'
        )
      ) {
        return null
      }
      return breadcrumb
    },
    integrations: [
      Sentry.replayIntegration({
        // See: https://docs.sentry.io/platforms/javascript/guides/react/session-replay/privacy/#privacy-configuration
        maskAllInputs: true,
        maskAllText: true,
        blockAllMedia: false,
        unmask: ['[data-sentry-unmask]', 'button', 'a', 'h1', 'h2', 'h3', 'h4'],
        mask: ['[data-sentry-mask]'],
        block: ['[data-sentry-block]'],
      }),
      // Filter out errors from third-party sources.
      // See https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['sentry-farewill-wills-fe-app-key'],
        // Defines how to handle errors that contain third party stack frames.
        // Possible values are:
        // - 'drop-error-if-contains-third-party-frames'
        // - 'drop-error-if-exclusively-contains-third-party-frames'
        // - 'apply-tag-if-contains-third-party-frames'
        // - 'apply-tag-if-exclusively-contains-third-party-frames'
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],

    // Capture Replay for 1% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
  })

  window.Sentry = Sentry
}
